/*
 * This is a renderless Component that GETS Announcements for the landing page. If is currently only called by
 * <LandingPageAnnouncements />
 */
import { useEffect }                         from 'react'
import axios                                 from 'axios'
import { node_server }                       from '../Helpers'
import PropTypes                             from 'prop-types'

const GetAnnountementsData = ({getData}) => {

   /* GET Announcements for the landing page
      res.data is { msg: 'get_announcements.php Is Up Man!', allAnnouncements: [ { MySQL data objects } ] } */
   useEffect( () => {
          axios.get(node_server + 'announcement')
          .then( res => {
            getData(res.data)
            /* Set axios headers back to what they were before. This was causing a cors error when calling the PHP server
            after a GET was made to the Node server. */
          } )
   }, [getData] )

   return null

}

GetAnnountementsData.propTypes = {
   getData: PropTypes.func,
 }

export default GetAnnountementsData
